import * as properties from "../properties";

class Storage {
    constructor() {

    }

    get(key, defaultValue) {
        var value = localStorage.getItem(key, defaultValue);
        return value;
    }

    set(key, value) {
        localStorage.setItem(key, value);
    }

    remove(key) {
        localStorage.removeItem(key);
    }

    removeAll() {
        localStorage.clear()
    }

    saveToken(value) {
        this.set(properties.token, value);
    }

    saveUserToken(value) {
        this.set(properties.usertoken, value);
    }

    getToken() {
        return this.get(properties.token);
    }

    getUserToken() {
        return this.get(properties.usertoken);
    }

    setExpireDate(value) {
        this.set(properties.expireDate, value);
    }

    setUserExpireDate(value) {
        this.set(properties.userexpireDate, value);
    }

    getExpireDate() {
        return this.get(properties.expireDate);
    }


    getUserExpireDate() {
        return this.get(properties.userexpireDate);
    }

    deleteAuthData() {
        this.remove(properties.token);
        this.remove(properties.expireDate);
    }

    deleteUserData() {
        this.remove(properties.usertoken);
        this.remove(properties.userexpireDate);
    }

    IsJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}

const storage = new Storage();

export default storage;